import { render, staticRenderFns } from "./ZodiacManagementDetailsScreen.vue?vue&type=template&id=e666b37e&scoped=true&"
import script from "./ZodiacManagementDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./ZodiacManagementDetailsScreen.vue?vue&type=script&lang=js&"
import style0 from "./ZodiacManagementDetailsScreen.vue?vue&type=style&index=0&id=e666b37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e666b37e",
  null
  
)

export default component.exports